const AtencionSinTurnoIcon = ({ color }) => {
  return (
    <svg
      width="19"
      height="24"
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23077 23.0769C3.07731 17.2454 0 12.63 0 9.23077C0 6.78262 0.972525 4.43473 2.70363 2.70363C4.43473 0.972525 6.78262 0 9.23077 0C11.6789 0 14.0268 0.972525 15.7579 2.70363C17.489 4.43473 18.4615 6.78262 18.4615 9.23077C18.4615 12.63 15.3842 17.2454 9.23077 23.0769ZM9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13Z"
        fill={ color }
      />
    </svg>
  );
};

export default AtencionSinTurnoIcon;
